import customConfig from 'customConfig'
import { MIN_BRAND_ACCOUNT_NUMBER_LENGTH } from 'src/constants/app'
import { ERROR_TEXT } from '../../constants/messages'
import { CUSTOM_BRAND_ID } from '../../constants/pointsExchange'
import { isExchangeProviderEmailType } from '../app/app.helpers'
import {
  isValidEtihadCardNumber,
  isValidMileAndMoreNumber
} from '../ffAccountValidation.helpers'
import {
  emailRule,
  isValidPositiveNumber,
  isValidRewardCode,
  requiredRule
} from './commonValidation.helpers'

const minPointsRule = (number, t, minPoints = 1, tokenSymbol) => {
  return !isValidPositiveNumber(number) || number < minPoints
    ? t(ERROR_TEXT.NEED_AT_LEAST_ONE_POINT, {
        points: minPoints,
        tokenSymbol
      })
    : ''
}

const MMAccountNumberRule = (number) => {
  return !isValidMileAndMoreNumber(number)
    ? ERROR_TEXT.INVALID_ACCOUNT_NUMBER
    : ''
}

const EtihadAccountNumberRule = (number) => {
  return !isValidEtihadCardNumber(number)
    ? ERROR_TEXT.INVALID_ACCOUNT_NUMBER
    : ''
}

const isValidUUID = (number) => {
  const valid =
    /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi
  return valid.test(number)
}

const UUIDRule = (accountNumber) => {
  return !isValidUUID(accountNumber.split(/-(.+)/)[1])
    ? ERROR_TEXT.INVALID_ACCOUNT_NUMBER
    : ''
}

const isValidSocialUsername = (number, min = 5, max = 32) => {
  const valid = new RegExp(`^@[a-zA-Z0-9_]{${min},${max}}$`)
  return valid.test(number)
}

const telegramUsernameRule = (accountNumber) => {
  return !isValidSocialUsername(accountNumber) ? 'error.invalid-username' : ''
}

const xUsernameRule = (accountNumber) => {
  return !isValidSocialUsername(accountNumber, 4, 15)
    ? 'error.invalid-username'
    : ''
}

const qbxTapUsernameRule = (accountNumber) => {
  const valid = /^[0-9]{1,24}$/gi
  return !valid.test(accountNumber) ? 'brand:eligible.invalid-qbx-tap-id' : ''
}

const brandAccountNumberRule = (value) => {
  const valueLength = value.length
  return valueLength < MIN_BRAND_ACCOUNT_NUMBER_LENGTH
    ? ERROR_TEXT.INVALID_ACCOUNT_NUMBER
    : ''
}

const validationRulesForAccountNumberSanity = (brandId) => {
  const rules = [requiredRule]
  if (brandId === CUSTOM_BRAND_ID.MILES_AND_MORE) {
    rules.push(MMAccountNumberRule)
  } else if (brandId === CUSTOM_BRAND_ID.ETIHAD) {
    rules.push(EtihadAccountNumberRule)
  } else if (brandId === CUSTOM_BRAND_ID.TELEGRAM) {
    rules.push(telegramUsernameRule)
  } else if (brandId === CUSTOM_BRAND_ID.X) {
    rules.push(xUsernameRule)
  } else if (brandId === CUSTOM_BRAND_ID.QBX_TAP) {
    rules.push(qbxTapUsernameRule)
  } else if (isExchangeProviderEmailType(brandId)) {
    rules.push(emailRule)
  } else {
    rules.push(brandAccountNumberRule)
  }
  return rules
}

const validRewardCodeRule = (rewardCode) => {
  const { min, max } = customConfig.rewardCodeRule
  return isValidRewardCode(rewardCode, min, max)
}

const moreThanZeroRule = (rate, value) => {
  return isEqualToZero(Math.floor(value * rate))
    ? ERROR_TEXT.NOT_SUFFICIENT_AMOUNT
    : ''
}

const isEqualToZero = (value) => {
  return value <= 0
}

const exceedLimitRule = (max, customError) => (value) => {
  return value > max ? customError || ERROR_TEXT.EXCEED_MAX_LIMIT : ''
}

const numberValidationRule = (numLimit = 10, decimalPoints = 4) => {
  return new RegExp(
    `^(\\d{0,${numLimit}}(\\.\\d{0,${decimalPoints}})?|\\.?,?\\d{0,${decimalPoints}})$`
  )
}

const validCryptoAmountRule = (number) => {
  return !numberValidationRule(10, 8).test(number)
    ? 'error.invalid-number-format'
    : ''
}

export {
  brandAccountNumberRule,
  EtihadAccountNumberRule,
  exceedLimitRule,
  minPointsRule,
  MMAccountNumberRule,
  moreThanZeroRule,
  UUIDRule,
  validationRulesForAccountNumberSanity,
  validCryptoAmountRule,
  validRewardCodeRule
}
